import styled from "styled-components"
import About from "../Components/About"
import Name from "../Components/Name"
import Navbar from "../Components/Navbar"
// import Photo from "../Components/Photo"
import Project from "../Components/Project"
import Skills from "../Components/Skills"
import Tech from "../Components/Tech"
import Photo from "../Components/Photo"
import { GithubStats } from "../Components/GithubStats"
import Contact from "../Components/Contact"
import { useEffect } from "react"
import Aos from "aos"
import "aos/dist/aos.css"
import { Box, Flex } from "@chakra-ui/react"
import Colour from "../Components/Colour"


function Home() {


    useEffect(() => {
        Aos.init({ duration: 2000 })
    }, [])


    return (
        <Box >

            <Navbar />
            <Colour />

            
                <Flex id="home" flexDirection={['column',"column" , "column","row"]} justifyContent={'space-around'} alignItems={['center']}>

                    <Photo />
                    <Name />
                </Flex>
            
            <About />
            <Skills />
            <Tech />
            <Project />
            <GithubStats />
            <Contact />

        </Box>

    )


}

export default Home

